import { MadeWithRpopro } from "@/components/VideoShowcase";
import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import { FullSpinner } from "@/components/Common";
import { PublicCard } from "@/components/PublicCard";
import { Footer } from "@/components/Footer";
import { API_BASE, enc } from "@/lib/api";

export default function PublicProfile() {
  const { slug } = useParams();
  const [d, setD] = useState(undefined);
  useEffect(() => {
    axios.get(`${API_BASE}/public/profile/${enc(slug)}`).then((r) => setD(r.data)).catch(() => setD(null));
  }, [slug]);
  useEffect(() => { if (d?.name) document.title = `${d.name} · MyNextBigMove.com`; }, [d]);

  if (d === undefined) return <FullSpinner />;
  return (
    <div className="grain flex min-h-screen flex-col bg-[#09090B]">
      <div className="relative z-[2] mx-auto w-full max-w-3xl flex-1 px-4 py-10 md:py-16">
        {d ? <div className="fade-up"><PublicCard d={d} /></div> : (
          <div className="py-24 text-center" data-testid="public-not-found">
            <h1 className="font-display text-3xl text-zinc-100">Profile not found</h1>
            <p className="mt-2 text-sm text-zinc-500">This link may have been unpublished.</p>
          </div>
        )}
        <MadeWithRpopro />
        <div className="mt-8 text-center">
          <Link to="/login" className="text-xs text-zinc-500 transition-colors hover:text-[#D4AF37]" data-testid="public-cta">Build your own AI-powered job search on RPOPRO.co →</Link>
        </div>
      </div>
      <Footer />
    </div>
  );
}
